import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";

const OMSUserSchema_ = z.object({
  roles: z.array(z.string().meta({ privacy: privacy.nonPii })).nullish(),
  _id: z.string().meta({ privacy: privacy.nonPii }),
  email: z.string().meta({ privacy: privacy.email }),
  createdAt: z.coerce.date().meta({ privacy: privacy.nonPii }),
  firstName: z.string().meta({ privacy: privacy.person_name }),
  lastName: z.string().meta({ privacy: privacy.person_name }),
  name: z.string().meta({ privacy: privacy.person_name }),
  updatedAt: z.coerce.date().meta({ privacy: privacy.nonPii }),
  team: zExt.objectId().meta({ privacy: privacy.nonPii }),
});
export const OMSUserSchema: z.ZodType<OMSUser> = OMSUserSchema_;
export interface OMSUser extends z.infer<typeof OMSUserSchema_> {}
export interface IOMSUser extends z.ZodType<OMSUser> {}

export const unassignedUser: OMSUser = {
  roles: null,
  _id: "unassigned",
  email: "",
  createdAt: new Date(),
  firstName: "Unassigned",
  lastName: "",
  name: "Unassigned",
  updatedAt: new Date(),
  team: "",
};
